/**
 * Utility for managing web storage objects
 *
 * @author John Lukose <john.lukose@quikr.com>
 */
import sessionStorageWrapper from './sessionStorageWrapper';
import localStorageWrapper from '../LocalStorageWrapper';
import Cookies from 'universal-cookie';

let webStorageWrapper = null;

class WebStorageWrapper {
    getLocalStorage = () => {
        return localStorageWrapper;
    }

    getCookie = () => {
        if (!this.cookieWrapper)
            this.cookieWrapper = new Cookies();

        return this.cookieWrapper;
    }

    getSessionStorage = () => sessionStorageWrapper;
}

webStorageWrapper = new WebStorageWrapper();
export default webStorageWrapper;



// WEBPACK FOOTER //
// ../q-jobs/src/utils/WebStorageWrapper/index.js